import { toast } from 'react-toastify';

// * Constant variables for message types
export const ERROR_NOTIFICATION = 0
export const INFO_NOTIFICATION = 1
export const SUCCESS_NOTIFICATION = 1

// * basic configuration for notification components
const defaultOptions = {
  position: "top-right",
  hideProgressBar: true,
  closeOnClick: true,
  autoClose: 5000
}
/**
  this class wraps the react-toastify functionality, to make it generic throughout the application.
 */
class ToastNotifications {
  notify(msg, type) {
    switch (type) {
      case ERROR_NOTIFICATION:
        toast.error(msg, {
          ...defaultOptions,
          autoClose: 6000
        })
        break;
      case INFO_NOTIFICATION:
        toast.info(msg, {
          ...defaultOptions
        })
        break;
        case SUCCESS_NOTIFICATION:
          toast.success(msg, {
            ...defaultOptions
          })
          break;
      default:
        toast(msg, {
          ...defaultOptions
        })
        break;
    }
  }
}

const toastNotifications = new ToastNotifications();

export default toastNotifications;
